import { emptyGuid } from 'constants/emptyGuid';
import * as Co2List from 'types/Co2Footprint/Co2FootprintList';

export type SaveCo2Footprint = {
	originLocationId: string;
	productionMethodId: string;
	value: number;
};

export const mapCarbonDioxide = (carbonDioxide: Co2List.Type): SaveCo2Footprint[] => {
	return carbonDioxide.map(
		(c) =>
			({
				originLocationId: c.originLocationId ? c.originLocationId : emptyGuid,
				productionMethodId: c.productionMethodId ? c.productionMethodId : emptyGuid,
				value: c.value,
			}) as SaveCo2Footprint
	);
};
